<script setup>
import KdContainer from "./kdContainer.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="400px">
      <div v-for="(sItem, index) in form.marketVehiclesList" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>
          <el-form-item
            label="海外市场及KD工厂车辆处置方案"
            :prop="`marketVehiclesList.${index}.inventoryVehicleDisposalSolution`"
            :rules="rules.inventoryVehicleDisposalSolution"
            v-show="sItem.hasInventoryVehicle == 1"
          >
            <el-input
              :disabled="sItem && sItem.inventoryVehicleDisposalSolution != ''"
              placeholder="请输入海外市场及KD工厂车辆处置方案"
              v-model="sItem.inventoryVehicleDisposalSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`marketVehiclesList.${index}.permanentSolutionFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>


          <el-form-item
            label="海外KD工厂、运输途中、鑫源及供应商处物料处置方案"
            :prop="`marketVehiclesList.${index}.reasonAnalyst`"
            v-show="sItem.hasMarketVehicle == 1"
          >
            <el-input
              :disabled="sItem && sItem.marketVehicleDisposalSolution !== ''"
              placeholder="请输入海外KD工厂、运输途中、鑫源及供应商处物料处置方案"
              v-model="sItem.marketVehicleDisposalSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>

          <el-form-item>
            <file-upload-list
              v-if="sItem && sItem.file !== ''"
              ref="fileUploadList"
              :fileList="sItem.file"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="sItem.file"
              :httpRequest="imAction"
            />
          </el-form-item>

        </div>
      </div>
      <div v-if="taskDefKey == 'Activity_1rsap6m' || taskDefKey == 'Activity_1qy6vq8'">
        <el-form-item label="是否升级质量中心" prop="isQuality">
          <el-radio-group :disabled="taskDefKey == 'Activity_1qy6vq8'" v-model="form.isQuality">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisibleUnit"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectUnitFormRef"
          label-width="140px"
        >
          <div
            class="rejectUnitInfo"
            v-for="(item, index) in form.rejectItems"
            :key="index"
          >
            <div class="delButton">
              <el-button
                v-if="index !== 0"
                type="text"
                icon="el-icon-delete"
                @click="delRejectUser(index)"
                >删除</el-button
              >
            </div>
            <el-form-item
              label="驳回责任单位人员"
              :prop="`rejectItems.${index}.userId`"
              :rules="rules.userId"
            >
              <el-select
                filterable
                clearable
                v-model="item.userId"
                placeholder="请选择驳回责任单位人员"
              >
                <el-option
                  v-for="item in userOptions.filter(
                    (optionItem) =>
                      !form.rejectItems.some(
                        (rejectItem) => rejectItem.userId === optionItem.userId
                      ) || optionItem.userId === item.userId
                  )"
                  :key="item.userId"
                  :label="item.staffName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="驳回原因"
              :prop="`rejectItems.${index}.rejectReason`"
              :rules="rules.rejectReason"
            >
              <el-input
                v-model="item.rejectReason"
                type="textarea"
                placeholder="请输入驳回原因"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            v-if="form.marketVehiclesList.length > form.rejectItems.length"
          >
            <el-button icon="el-icon-plus" type="text" @click="addRejectUser()"
              >新增责任单位人员</el-button
            >
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisibleUnit = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>


      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>

    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";
/**
 * 15.2-QE确认永久方案和计划改善时间
 */
export default {
  name: "kdQeSkillManagerPackMarketSchemeAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    marketVehiclesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      dialogVisibleUnit: false,
      auditPassDialogVisible: false,
      form: {
        isQuality: 0,
        auditText: "",
        rejectReason: "",
        marketVehiclesList: [
          {
            inventoryVehicleDisposalSolutionFiles:[],
            marketVehicleDisposalSolutionFiles:[],
            hasInventoryVehicle: 1,
            hasMarketVehicle: 1,
            inventoryVehicleDisposalSolution: "",
            marketVehicleDisposalSolution: "",
            inventoryVehicleHandStatusMessage: "",
            inventoryVehicleHandStatusMessageFiles: [],
          },
        ],
        rejectItems: [
          {
            userId: "",
            rejectReason: "",
          },
        ],
        handSuggestion: "",
        handSuggestionFiles: [],
      },
      userOptions: [],
      rules: {
        reasonAnalyst: [
          {
            required: true,
            message: "根因分析不能为空",
            trigger: ["blur", "change"],
          },
        ],
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur"],
          },
        ],
        userId: [
          {
            required: true,
            message: "驳回责任单位人员不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        faultVideoList: this.form.handSuggestionFiles,
        variables: {
          approval: true,
          isQuality: this.form.isQuality !== 0,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      if (this.taskDefKey == 'Activity_1my3ohs'){
        this.dialogVisibleUnit = true;
        this.form.rejectItems= [
          {
            userId: "",
            rejectReason: "",
          }
        ];
        this.$nextTick(() => {
          this.$refs.rejectUnitFormRef?.resetFields();
        });
      } else {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.rejectFormRef?.resetFields();
        })
      }
    },
    auditRejectSubmit() {
      const formRef = this.dialogVisibleUnit ? this.$refs.rejectUnitFormRef : this.$refs.rejectFormRef;
      formRef.validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
          rejectItems: this.form.rejectItems,
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
            this.dialogVisibleUnit = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
    addRejectUser() {
      if (this.form.rejectItems.length > this.form.marketVehiclesList.length) {
        this.$DonMessage.warning("添加驳回数量超过上限！");
        return;
      }
      this.form.rejectItems.push({
        userId: "",
        rejectReason: "",
      });
    },
    delRejectUser(index) {
      this.form.rejectItems.splice(index, 1);
    },
  },
  mounted() {
    if (this.marketVehiclesList) {
      this.form.marketVehiclesList = this.marketVehiclesList;
      this.userOptions = this.marketVehiclesList;
    }
  },
};
</script>
